/******/ (() => { // webpackBootstrap
/*!***********************************!*\
  !*** ./src/js/recently-viewed.js ***!
  \***********************************/
/*
BG: Uses localStorage to store the products the user visits, and displays it back to the customer in a recently viewed section.
*/

var recentlyViewedProducts = function recentlyViewedProducts() {
  var recentlyViewed = document.querySelector('.js-recently-viewed-products');
  var maxProducts = 6;
  var savedRecentProducts = JSON.parse(localStorage.getItem("recentProducts"));
  //by default, we assume the prodict array is empty. 
  var productArray = [];
  var flickityPresent = false;

  //We planning on using flickity?, we check to see if the inline attribute is present.
  if (recentlyViewed.hasAttribute('data-flickity')) {
    flickityPresent = true;
  }

  //if localstorage exists, retrieve the list and output it
  if (savedRecentProducts) {
    //BG: if array is greater than the maxProducts, then delete the first item in the array
    if (savedRecentProducts.length > maxProducts) {
      savedRecentProducts.shift();
    }
    //update the product array to be the array stored in localStorage.
    productArray = savedRecentProducts;
    if (productArray.length >= 3) {
      recentlyViewed.parentNode.classList.remove('hidden');
    }
    var countClass = null;
    if (productArray.length < 2) {
      recentlyViewed.classList.add('recently-viewed-products--undertwo');
    } else if (productArray.length < 3) {
      recentlyViewed.classList.add('recently-viewed-products--underthree');
    } else if (productArray.length < 4) {
      recentlyViewed.classList.add('recently-viewed-products--underfour');
    }
    if (productArray.length >= 3) {
      var promiseList = [];
      var reference = [];
      productArray.forEach(function (productHandle, index) {
        promiseList.push(fetch(window.Shopify.routes.root + "products/".concat(productHandle, "?view=card")).then(function (response) {
          if (!response.ok) return null;
          return response.text();
        }));
        reference.push(productHandle);
      });
      Promise.all(promiseList).then(function (htmls) {
        var finalHtml = '';
        htmls.forEach(function (html, index) {
          if (html != null) {
            var preview = html.slice(0, 26);
            if (preview.includes("product-card")) {
              finalHtml += html;
            } else {
              //if the preview doesn't include the product card, we're not returning what we expect, remove it from the array.
              var removeProd = productArray.indexOf(reference[index]);
              if (removeProd > -1) {
                productArray.splice(removeProd, 1);
              }

              //BG: Update localStorage, so we don't try and show it again.
              localStorage.setItem("recentProducts", JSON.stringify(productArray));
            }
          } else {
            //if the preview doesn't include the product card, we're not returning what we expect, remove it from the array.
            var _removeProd = productArray.indexOf(reference[index]);
            if (_removeProd > -1) {
              productArray.splice(_removeProd, 1);
            }

            //BG: Update localStorage, so we don't try and show it again.
            localStorage.setItem("recentProducts", JSON.stringify(productArray));
          }
        });
        var recentlyViewed = document.querySelector('.js-recently-viewed-products');
        recentlyViewed.innerHTML = finalHtml;
        if (recentlyViewed.hasAttribute('data-flickity-special') == true) {
          var options = JSON.parse(recentlyViewed.getAttribute('data-flickity-special'));
          new Flickity('.js-recently-viewed-products', options);
        }
      });
    }
  }
  // if the recently viewed section has the product handle, add this product to the array.
  if (recentlyViewed.hasAttribute('data-product-handle')) {
    var productHandle = recentlyViewed.getAttribute('data-product-handle');

    //BG: only add the product to the array, if it doesn't already exist
    if (productArray.indexOf(productHandle) == -1) {
      productArray.push(productHandle);
    }
    //BG: Update localStorage
    localStorage.setItem("recentProducts", JSON.stringify(productArray));
  }
};

//check if the section exists, if so, run the function.
if (!!document.querySelector('.js-recently-viewed-products')) {
  recentlyViewedProducts();
}
/******/ })()
;